/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_EmptyInputs */

const cs_settings_venues_empty = /** @type {(inputs: Settings_Venues_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné pobočky`)
};

const en_settings_venues_empty = /** @type {(inputs: Settings_Venues_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No offices yet`)
};

/**
* | output |
* | --- |
* | "No offices yet" |
*
* @param {Settings_Venues_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_empty = /** @type {((inputs?: Settings_Venues_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_empty(inputs)
	return cs_settings_venues_empty(inputs)
});